import {
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
} from "@mui/material";
import Paper from "@mui/material/Paper";
import { PaymentIcon } from "react-svg-credit-card-payment-icons";
import { formatearPesoMXN } from "../../../utilis/formatter";
import { formatErrorMessage } from "../../../utilis/errorFormatter";
import StatusLabel from "../../../components/utils/StatusLabel";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import CheckIcon from "@mui/icons-material/Check";
import { useState } from "react";

export const TransactionModal = ({ data }: any) => {
  const [copied, setCopied] = useState(false);

  function createData(name: string, calories: any) {
    return { name, calories };
  }

  const isMovementLink =
    String(data?.movement_type || "").toLowerCase() === "movement_link";

  const paymentLink =
    data?.payment_url || data?.payment_method?.url || data?.payment_method?.data?.url || "";

  const handleCopyPaymentLink = async () => {
    if (!paymentLink) return;

    try {
      await navigator.clipboard.writeText(paymentLink);
      setCopied(true);
      setTimeout(() => setCopied(false), 1800);
    } catch {
      setCopied(false);
    }
  };

  const checkTransaction = (data: any) => {

    let message
    if (data?.metadata?.PROCESSOR_ADVICE) {
      if (data.metadata.SERVICE_ADVICE !== "Declined") {
        return formatErrorMessage(data.metadata.SERVICE_ADVICE) ;
      }
      if (data.metadata.API_ADVICE.length > 2) {
        return formatErrorMessage(data.metadata.API_ADVICE);
      }
      if (data.metadata.PROCESSOR_ADVICE.length > 0) {
        return formatErrorMessage(data.metadata.PROCESSOR_RESPONSE) ;
      }
    }

    if (data?.status === "APPROVED" || data?.status === "completed") {
      return "Transacción aprobada por el banco";
    }

    if (data?.status === "EXPIRED" || data?.status === "EXPIRED") {
      return "Transacción expirada";
    }

    if (data?.status === "DECLINED" || data?.status === "EXPIRED") {
      return "Transacción declinada";
    }

    if (data?.status === "failed") {
      return "Transacción declinada(No paso verificación de banco)";
    }
    if (data?.status === "CHARGE_PENDING") {
      return "Transacción en estado de espera";
    }

    if (data?.status === "COMPLETED") {
      return "Transacción se ha completado";
    }

    return "Fallo al momento de realizar la transacción";
  };

  const rows = [
    createData("Nombre de cliente:", data?.full_name),
    createData("Email:", data?.email),
    createData(
      "Tipo de Tarjeta:",
      <PaymentIcon type={data?.card_brand} format="flatRounded" width={36} />
    ),
    createData("Cobro:", " " + formatearPesoMXN(data?.amount) ),
    createData("Comisión:", " " + formatearPesoMXN(data?.comission?.bo_commission?.commission) ),
    createData(
      "Fecha:",
      new Date(data?.created_at).toLocaleDateString("es-MX", {
        year: "numeric",
        month: "numeric",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
        second: "numeric",
        timeZone: "America/Mexico_City",
      })
    ),
    createData("Rastreo:", data?._id.slice(-5)),
    createData("Estatus:", <StatusLabel value={data?.status} withStyle={false} />),
    createData("Estado de transacción:", data?.status_description),
   // createData("Respuesta de banco:", checkTransaction(data)),
    ...(isMovementLink && paymentLink
      ? [
          createData(
            "Link de pago:",
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-end",
                gap: "8px",
                width: "100%",
              }}
            >
              <span style={{ maxWidth: "280px", wordBreak: "break-all" }}>
                {paymentLink}
              </span>
              <Tooltip title={copied ? "Copiado" : "Copiar link"}>
                <IconButton size="small" onClick={handleCopyPaymentLink}>
                  {copied ? <CheckIcon fontSize="small" /> : <ContentCopyIcon fontSize="small" />}
                </IconButton>
              </Tooltip>
            </div>
          ),
        ]
      : []),
  ];

  return (
    <div>
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 400 }} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell></TableCell>
              <TableCell align="right">Información</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row) => (
              <TableRow
                key={row.name}
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              >
                <TableCell
                  style={{ fontWeight: "bold" }}
                  component="th"
                  scope="row"
                >
                  {row.name}
                </TableCell>
                <TableCell align="right">{row.calories}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};
